export enum ProfileHttpPaths {
  profile = '/api/v1.0/staff/profile',
  employment = '/api/v1.0/staff/employments',
  skills = '/api/v1.0/staff/skills',
  appointments = '/api/v1.0/staff/appointments',
  staffDetails = '/api/v1.0/staff/details',
  resetPassword = '/api/v1.0/authentication/reset-password',
  cautionAndConvictions = '/api/v1.0/cautions-and-convictions',
  downloadCautionAndConvictionsCertificate = '/api/v1.0/cautions-and-convictions/{###}/certificate',
  shiftsPreference = '/api/v1.0/staff/shifts/preference',
}

enum ProfileHttpRecordGroup {
  primary = 'Home',
  nok = 'NextOfKin',
}

export class ProfileHttpStaffPaths {
  public static email = '/api/v1.0/staff/email';
  public static fullName = '/api/v1.0/staff/full-name';
  public static preferredName = '/api/v1.0/staff/preferred-name';
  public static gender = '/api/v1.0/staff/gender';
  public static languages = '/api/v1.0/staff/languages';
  public static nokFullName = '/api/v1.0/staff/next-of-kin-full-name';
  public static nokRelationship = '/api/v1.0/staff/next-of-kin-relationship';
  public static primaryAddress = `/api/v1.0/staff/addresses/${ProfileHttpRecordGroup.primary}`;
  public static nokAddress = `/api/v1.0/staff/addresses/${ProfileHttpRecordGroup.nok}`;
  public static bankDetails = `/api/v1.0/staff/bank-details`;
  public static employers = '/api/v1.0/staff/employments';
  public static primaryPhoneNumber = `/api/v1.0/staff/phone-numbers/${ProfileHttpRecordGroup.primary}`;
  public static nokPhoneNumber = `/api/v1.0/staff/phone-numbers/${ProfileHttpRecordGroup.nok}`;
}
